import React, { memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const CarouselSlide = ({ image, placeholder, classes }) => {
    const [hasError, setHasError] = useState(false);

    const handleError = useCallback(() => {
        if (placeholder && !hasError) {
            setHasError(true);
        }
    }, [placeholder, hasError]);

    const imageSrc = hasError ? placeholder : image?.original;

    return (
        <div className={classes.slide}>
            <img
                className={classes.slideImage}
                src={imageSrc}
                alt=""
                onError={handleError}
                draggable={false}
            />
        </div>
    );
};

CarouselSlide.propTypes = {
    image: PropTypes.shape({
        original: PropTypes.string,
        thumbnail: PropTypes.string,
    }),
    placeholder: PropTypes.string,
    classes: PropTypes.object.isRequired,
};

export default memo(CarouselSlide);
